<template>
  <div class="h-fill bg-f3f">
    <div v-if="!$parent.appInner || !$parent.isAndroid" class="h-55"></div>
    <div class="pd-t-10">
      <div class="bg-f mg-l-10 mg-r-10 bdr-10 shadow-2">
        <div class="info-row align-items-center" @click="onAvatarClick">
          <div class="fs-16">头像</div>
          <div class="align-items-center">
            <img :src="user.avatar || defaultAvatar" class="w-50 h-50 bdr-circular bg-e8e"/>
            <van-icon name="arrow" class="mg-l-10 c-9"/>
          </div>
        </div>
        <div class="info-row align-items-center" @click="onNicknameClick">
          <div class="fs-16">昵称</div>
          <div class="align-items-center">
            <span class="fs-16 c-3">{{ user.nickname || '未设置' }}</span>
            <van-icon name="arrow" class="mg-l-10 c-9"/>
          </div>
        </div>
        <div class="info-row align-items-center">
          <div class="fs-16">手机号</div>
          <div class="fs-16 c-3">{{ user.phone || '-' }}</div>
        </div>
      </div>
      <p class="fs-12 text-align-center mg-t-10 c-7">APP版本号：{{ $parent.appVersion }}</p>
    </div>

    <div class="position-fixed b-30 l-0 r-0 display-flex justify-content-center">
      <div class="c-9 fs-14 cursor-pointer" @click="onDestroyClick">注销并删除账号</div>
    </div>

    <input ref="avatarInput" type="file" accept="image/*" class="display-none" @change="onAvatarChange"/>

    <van-dialog v-model="showNicknameDialog" title="修改昵称" show-cancel-button
                :before-close="onNicknameDialogClose">
      <div class="pd-20">
        <van-field v-model="editNickname" maxlength="20" placeholder="请输入昵称" class="bg-f3f"/>
      </div>
    </van-dialog>

    <div v-if="!$parent.appInner || this.$parent.isIos"
         class="position-fixed t-0 w-fill align-items-center h-50 shadow-2 z-index-999 bg-f">
      <div class="flex-1">
        <van-icon name="arrow-left" class="pd-15" @click="onBackClick"/>
      </div>
      <div class="flex-1 text-align-center">
        用户信息
      </div>
      <div class="flex-1"></div>
    </div>
  </div>
</template>

<script>
import request from '../libs/api.request'
import storage from '../libs/storage'
import util from '../libs/util'

const DEFAULT_AVATAR = 'https://anki-resource.oss-cn-shenzhen.aliyuncs.com/default/user-avatar.png'

export default {
  name: "userInfo",
  data() {
    return {
      user: {
        avatar: '',
        nickname: '',
        phone: '',
      },
      defaultAvatar: DEFAULT_AVATAR,
      showNicknameDialog: false,
      editNickname: '',
    }
  },
  methods: {
    fetchUserInfo() {
      request.request({
        url: 'user/getInfo'
      }).then((data) => {
        this.user = {
          avatar: data.avatar || '',
          nickname: data.nickname || '',
          phone: data.phone || '',
        }
        this.syncLoginUser(data)
      }).catch((err) => {
        if (err && (err.code === 401 || err.code === 403)) {
          this.$parent.login()
        } else {
          this.$toast(err.message || '获取用户信息失败')
        }
      })
    },
    syncLoginUser(data) {
      this.$parent.loginUser = data
      storage.setUserInfo(data)
    },
    saveInfo(data) {
      return request.request({
        url: 'user/saveInfo',
        data,
        method: 'post'
      }).then((result) => {
        const newUser = Object.assign({}, this.user, data)
        this.user = newUser
        this.syncLoginUser(Object.assign({}, this.$parent.loginUser || {}, data))
        return result
      })
    },
    onAvatarClick() {
      this.$refs.avatarInput.click()
    },
    onAvatarChange(e) {
      const file = e.target.files[0]
      e.target.value = ''
      if (!file) {
        return
      }
      if (!file.type.startsWith('image/')) {
        this.$toast('请选择图片文件')
        return
      }
      const formData = new FormData()
      formData.append('file', file)
      this.$toast.loading({message: '上传中...', duration: 60000, overlay: true})
      request.upload({
        url: 'common/uploadImg',
        data: formData,
        method: 'post'
      }).then((data) => {
        return this.saveInfo({avatar: data.url})
      }).then(() => {
        this.$toast.clear()
        this.$toast('头像修改成功')
      }).catch((err) => {
        this.$toast.clear()
        if (err && (err.code === 401 || err.code === 403)) {
          this.$parent.login()
        } else {
          this.$toast(typeof err === 'string' ? err : (err.message || '上传失败'))
        }
      })
    },
    onNicknameClick() {
      this.editNickname = this.user.nickname || ''
      this.showNicknameDialog = true
    },
    onNicknameDialogClose(action, done) {
      if (action === 'confirm') {
        const nickname = this.editNickname.trim()
        if (!nickname) {
          this.$toast('昵称不能为空')
          done(false)
          return
        }
        if (nickname === this.user.nickname) {
          done()
          return
        }
        this.$toast.loading({message: '', duration: 60000, overlay: true})
        this.saveInfo({nickname}).then(() => {
          this.$toast.clear()
          this.$toast('昵称修改成功')
          done()
        }).catch((err) => {
          this.$toast.clear()
          if (err && (err.code === 401 || err.code === 403)) {
            this.$parent.login()
          } else {
            this.$toast(err.message || '修改失败')
          }
          done(false)
        })
      } else {
        done()
      }
    },
    onDestroyClick() {
      let message = '重要提醒：此功能不是退出登录！！您在Anji记忆卡、Anymo APP使用此手机号登陆的账号都会被注销，您制作或购买的卡牌/会员等个人数据所有信息将被永久删除无法找回。如您只希望退出登录请返回【设置】页面点击顶部的\'退出\'';
      this.$dialog.confirm({
        message,
        confirmButtonText: '不注销',
        cancelButtonText: '确认注销',
      }).catch(() => {
        this.$router.push({path: '/destroy-user'})
      });
    },
    onBackClick() {
      if (this.$parent.appInner && this.$parent.isIos) {
        if (util.compareVersionIfMax(this.$parent.appVersion, '3.6.1')) {
          akBridge.callHandler('akClosePage');
        } else {
          this.$toast('下滑页面返回APP')
        }
        return
      }
      this.$router.back()
    }
  },
  mounted() {
    document.title = '用户信息'
    if (!this.$parent.loginUser && !this.$cookies.get('authToken')) {
      this.$parent.login()
      return
    }
    if (this.$parent.loginUser) {
      this.user = {
        avatar: this.$parent.loginUser.avatar || '',
        nickname: this.$parent.loginUser.nickname || '',
        phone: this.$parent.loginUser.phone || '',
      }
    }
    this.fetchUserInfo()
  }
}
</script>

<style scoped>
.info-row {
  display: flex;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #f5f5f5;
}

.info-row:last-child {
  border-bottom: none;
}
</style>
